import { CloseIcon } from "@chakra-ui/icons";
import { Box, IconButton, Spacer, Text, ToastProviderProps } from "@chakra-ui/react";

import { RanaAlert } from "../components/rana-alert";
import { RanaHeading } from "../components/rana-heading";

export const ranaToastOptions: ToastProviderProps = {
  defaultOptions: {
    position: "bottom",
    duration: 5000,
    isClosable: true,
    render: ({ title, isClosable, onClose, description, status }) => {
      return (
        <RanaAlert
          status={status ?? "success"}
          position="relative"
          alignItems="center"
          w="full"
          p={4}
          gap={4}
          textStyle="sm"
          maxW="lg"
          minW="md"
        >
          <Box>
            <RanaHeading type="h4" mb={2}>
              {title}
            </RanaHeading>
            <Text textStyle="sm">{description}</Text>
          </Box>

          {isClosable && (
            <>
              <Spacer />
              <IconButton
                aria-label="close"
                variant="ghost"
                size="xs"
                colorScheme="whiteAlpha"
                icon={<CloseIcon />}
                onClick={onClose}
              />
            </>
          )}
        </RanaAlert>
      );
    },
  },
};
